import React, {useState, useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import {withTranslation} from "react-i18next";
import {Row, Col, Alert} from "antd";
import {useTranslation} from "react-i18next";
import {tutorAuthActions} from "_actions";
import {useLocation} from "react-router-dom";



function useQuery() {
  const {search} = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function ActivateTutor(props) {
  let query = useQuery();
  const dispatch = useDispatch();
  const {t, i18n} = useTranslation();
  const [loading, setLoading] = useState(false);

  const tokenActivation = query.get("token");

  var tutorActivationResult = useSelector((state) => state.authReducer.tutorValidated);
  const [errorActivation, setErrorActivation] = useState(false);
  useEffect(() => {
    dispatch(tutorAuthActions.activateCounselorByToken(tokenActivation));

  }, []);


  useEffect(() => {
    if(tutorActivationResult==false){
      setErrorActivation(true);
    }
  }, [tutorActivationResult]);

  return (
    <>
      <Row justify="space-around" align="middle">
        <Col> 
        {errorActivation && <Alert message={t("login.errorMsgActivate")} type="error" />}
        </Col>
      </Row>
    </>
  );
}
export default withTranslation()(ActivateTutor);
